import React from 'react';
import { useEditorContext } from '../../Editor/Context';
import SelectionBubbleMenu from '../SelectionBubbleMenu';
import { LinkMenuState } from '../../../extensions/extension-link-menu-handler/linkMenuHandler';
import Dream from '../buttons/Dream';
import { isTouch } from '../../utils/browser';
import { isExtensionInstalled } from '../../utils/tiptap';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
const DreamBubbleMenu = ({ scrollContainerRef })=>{
    const editor = useEditorContext();
    const isEditorMuro = useFlag('editor_muro');
    if (!editor || !isEditorMuro) {
        return null;
    }
    if (!isExtensionInstalled(editor, 'muro')) {
        return null;
    }
    if (!(editor === null || editor === void 0 ? void 0 : editor.isEditable) || isTouch()) {
        return null;
    }
    const buttonCount = 1;
    const handlerStorage = editor.storage.linkBubbleMenuHandler;
    const menuState = handlerStorage.state;
    if (menuState === LinkMenuState.VIEW_LINK_DETAILS) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(SelectionBubbleMenu, {
        scrollContainerRef: scrollContainerRef,
        menuHeight: 34,
        menuWidth: 32 * buttonCount,
        editor: editor,
        open: !editor.state.selection.empty,
        forceBelowSelection: true
    }, /*#__PURE__*/ React.createElement("div", {
        // className={cn('ds-surface-tertiary')}
        style: {
            maxWidth: '100vw',
            display: 'flex',
            flexWrap: 'wrap',
            border: '1px solid transparent',
            backgroundImage: 'linear-gradient(var(--g-card-bg), var(--g-card-bg)), radial-gradient(circle at top left, #da499b, #5238f2)',
            backgroundOrigin: 'border-box',
            backgroundClip: 'content-box, border-box'
        }
    }, /*#__PURE__*/ React.createElement(Dream, {
        editor: editor
    })));
};
DreamBubbleMenu.displayName = 'FormatBubbleMenu';
export default DreamBubbleMenu;

//# sourceMappingURL=DreamBubbleMenu.js.map